import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import useToken from '../../../hooks/use-token';
import saveUserCars from '../../../services/user/save-cars';
import { useAppContext } from '../../providers/app-context';

const useSelectVehicle = () => {
  const { locale = 'en' } = useRouter();
  const token = useToken();
  const {
    concent: { preferences },
  } = useAppContext();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation(saveUserCars,
    {
      onSuccess: () => {
        queryClient.resetQueries({
          queryKey: ['user-dependent', 'cars', 'saved-cars']
        })
        queryClient.resetQueries({
          queryKey: ['user-dependent', 'saved-cars']
        })
      }
    }
  );

  return (slug: string) => {
    preferences &&
      mutateAsync({
        csrftoken: token,
        locale,
        car_identifier: slug,
      });
  };
};

export default useSelectVehicle;
